// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","487":"1ebde006","990":"9bdcab81"}[chunkId] + ".chunk.js";
};